import { useInjection } from 'inversify-react';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import type { IAnalyticsService } from '../../services/analytics/analytics.service.interface';
import type { AnalyticsEventMap, AnalyticsEventName } from '../../services/analytics/events';

export function useAnalytics() {
  const analytics = useInjection<IAnalyticsService>(AnalyticsService);

  function trackEvent<E extends AnalyticsEventName>(name: E, params: AnalyticsEventMap[E]): void {
    analytics.trackEvent(name, params);
  }

  function setIdentityEmail(email: string | undefined | null): void {
    analytics.setIdentityEmail(email);
  }

  return { trackEvent, setIdentityEmail };
}
